module.exports = __webpack_public_path__ + "img/bsjg_05.c8279246.png";